import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import { Loadable } from '../base/components/Lodable.tsx'

const AlmacenGestion = Loadable(lazy(() => import('./view/AlmacenGestion.tsx')))

export const almacenRoutesMap = {
  gestion: {
    path: '/almacen/gestion',
    name: 'Almacenes',
    action: 'ALMACENES',
  },
  registro: {
    path: '/almacen/nuevo',
    name: 'Nuevo Almacen',
    action: 'ADMINISTRAR_ALMACEN',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const almacenRoutes = [
  {
    path: almacenRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <AlmacenGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default almacenRoutes
